import React, { forwardRef } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Modal as ModalUnstyled } from '@mui/base'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { IconButton } from '../button/IconButton'

import './modal.scss'

const Backdrop = forwardRef((props, ref) => {
  const { open, className, ...other } = props

  return (
    <div
      className="modal-backdrop"
      ref={ref}
      {...other}
    />
  )
})

export const Modal = ({ display, setDisplay, title, children }) => {
  const handleClose = () => {
    setDisplay(false)
  }

  return (
    <ModalUnstyled 
      open={display}
      onClose={handleClose}
      components={{ Backdrop }}>
      <div className="modal-content-container">
        <div className="modal-content">
          <div className="close-container">
            <IconButton onClick={handleClose} icon={faXmark} />
          </div>

          <Row>
            {title && (
              <Col sm={12}>
                <h2 className="modal-title">
                  {title}
                </h2>
              </Col>
            )}
            <Col sm={12}>
              {children}
            </Col>
          </Row>
        </div>
      </div>
    </ModalUnstyled>
  )
}
